import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-content relative" }
const _hoisted_3 = { class: "absolute max-w-[140px] md:max-w-[160px] ltr:-right-[9px] rtl:-left-[9px] top-1/2 -translate-y-1/2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<span class=\"block mb-[5px]\"> Clicks </span><div class=\"flex items-center\"><h6 class=\"mb-0 text-[20px]\">4,500</h6><span class=\"inline-block font-medium relative text-[10px] ltr:ml-[11px] rtl:mr-[11px] rounded-sm bg-success-100 text-success-600 py-[1.5px] ltr:pl-[25px] rtl:pr-[25px] ltr:pr-[7px] rtl:pl-[7px]\"><i class=\"ri-arrow-up-s-fill absolute ltr:left-[2px] rtl:right-[2px] text-[22px] top-1/2 -translate-y-1/2\"></i> 37.5% </span></div><span class=\"text-xs block mt-[29px]\"> Last 30 days </span>", 3)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "area",
              height: "150",
              options: _ctx.clicksChart,
              series: _ctx.clicks
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}